// Human-readable payment methods derived from a salary's payment_rail + banking_provider.
// Framework-agnostic (no @/utils import) so it stays unit-testable in jest.
export const PAYMENT_METHOD_LABELS = {
  STREAM_ACCOUNT: 'Stream account',
  CARD: 'Card',
  ACH_EXTERNAL: 'ACH (external)',
  ACH: 'ACH',
  PAYROLL: 'Payroll',
  UNKNOWN: '—',
};

// Raw values from paydays-api (us/pubapi/common/banking_provider.py); both fields nullable on older salaries.
const STREAM_ACCOUNT_PROVIDERS = ['SVB', 'WELLSFARGO', 'TREASURYPRIME', 'PIERMONT', 'BMO'];
const PAYROLL_PROVIDERS = ['OSV', 'OSV_FISERV'];

// Map a salary row's rail/provider to a payment method; falls back to '—' when unknown/null.
export const formatPaymentMethod = row => {
  const rail = row?.payment_rail || null;
  const provider = row?.banking_provider || null;

  if (rail === 'PAYROLL_OSV' || PAYROLL_PROVIDERS.includes(provider)) {
    return PAYMENT_METHOD_LABELS.PAYROLL;
  }
  if (STREAM_ACCOUNT_PROVIDERS.includes(provider)) {
    return PAYMENT_METHOD_LABELS.STREAM_ACCOUNT;
  }
  if (provider === 'TABAPAY') {
    return PAYMENT_METHOD_LABELS.CARD;
  }
  if (provider === 'PLAID') {
    return PAYMENT_METHOD_LABELS.ACH_EXTERNAL;
  }
  if (rail === 'ACH') {
    return PAYMENT_METHOD_LABELS.ACH;
  }
  return PAYMENT_METHOD_LABELS.UNKNOWN;
};
